import {Component, Inject} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'cp-sure-dialog',
    templateUrl: 'confirmation-dialog.component.html',
    standalone: false
})

export class ConfirmationDialogComponent {

    constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
                public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    text: string | null;
                    confirmationYes: string | null;
                    confirmationNo: string | null
                } | null
    ) {
    }
}